import { Alert, AlertTitle, Box, Typography } from '@mui/material';
import { useAuth } from '@/lib/auth/AuthContext';

/**
 * Ekran pokazywany, gdy użytkownik NIE MA PRAWA oglądać danych o dostawach.
 *
 * ┌─ CO ZASTĘPUJE ──────────────────────────────────────────────────────────────────────────────┐
 * │ Do niedawna w tym miejscu stał DRUGI FORMULARZ LOGOWANIA: dane o dostawach były w innym    │
 * │ systemie, z innym katalogiem kont, więc Control Center prosił o kolejne hasło.              │
 * │                                                                                             │
 * │ Ten koszt zniknął, bo do źródeł chodzi teraz backend własną tożsamością serwisową. Nie ma  │
 * │ już czegoś takiego jak „użytkownik niepodłączony do systemu kierowców".                     │
 * │                                                                                             │
 * │ Zostało coś innego i uczciwszego: brak UPRAWNIENIA. Ekran mówi to wprost i nie proponuje    │
 * │ żadnego sposobu obejścia — bo obejściem uprawnienia jest wyłącznie nadanie uprawnienia.     │
 * └─────────────────────────────────────────────────────────────────────────────────────────────┘
 */
export function BrakDostepuDoDostaw() {
  const auth = useAuth();
  const rola = auth.realms.cc?.identity?.roles?.[0] ?? null;

  return (
    <Box>
      <Typography variant="h4" component="h1" sx={{ mb: 2 }}>
        Punktualność dostaw
      </Typography>

      <Alert severity="info" sx={{ mb: 3 }}>
        <AlertTitle>Brak uprawnienia do danych o dostawach</AlertTitle>
        <Typography variant="body2" sx={{ mb: 1 }}>
          Twoje konto nie ma uprawnienia <code>analytics.delivery.read</code>
          {rola ? <> — rola <strong>{rola}</strong> go nie obejmuje.</> : '.'}
        </Typography>
        <Typography variant="body2">
          To nie jest brak połączenia ani awaria. Control Center sięga do systemu kierowców po
          stronie serwera i nie prosi o osobne hasło; decyduje wyłącznie zakres Twojego konta.
          O rozszerzenie uprawnień poproś administratora.
        </Typography>
      </Alert>
    </Box>
  );
}
